import React from "react";
import { Routes, Route } from "react-router-dom";
import { publicRoutes, authRoutes, adminRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import NotFound from "../pages/NotFound";

// Define o tipo de uma rota com ou sem filhos
type RouteItem = {
  path: string;
  element: React.ReactNode;
  children?: RouteItem[];
};

// função auxiliar para lidar com rotas com ou sem children
const renderRoutes = (routesArray: RouteItem[]) =>
  routesArray.map(({ path, element, children }, idx) => (
    <Route path={path} element={element} key={idx}>
      {children &&
        children.map((child, index) => (
          <Route path={child.path} element={child.element} key={index} />
        ))}
    </Route>
  ));

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Rotas públicas com layout Feature */}
      <Route element={<Feature />}>
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}
      </Route>

      {/* Rotas protegidas com layout AuthFeature */}
      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}
      </Route>

      {/* Rotas administrativas com layout AdminLayout */}
      {renderRoutes(adminRoutes)}

      {/* Rota 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ALLRoutes;
